import { ServicePartsVersionDTO } from '../../../Domain/DTO/ServicePartsVersionDTO';
import { IEntityDTO } from '../../../Domain/IEntityDTO';
import { BaseEntityPropsInitial, IBaseEntityProps } from '../BaseEntity/IBaseEntityProps';

export interface IAboutProps extends IBaseEntityProps<ServicePartsVersionDTO, {}>, IEntityDTO {
}

export const AboutPropsInitial: IAboutProps = { ...BaseEntityPropsInitial};